/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { PDFViewer } from "@react-pdf/renderer";
import React, { useContext, useEffect, useState } from "react";
import GlobalTable from "../../../components/global-table";
import { Box, Button, Col, Dialog, InputField, Row, SelectField, Typography } from "../../../ppui";
import { theme } from "../../../theme";
import { getMonthInStringNotOneIndexBased } from "../../../utils/common";
import {
	ContentLayout,
	ContentTable,
} from "../../style";
import SalaryReportPdf from "../salary-report/salary-report";
import BankDisbursmentPDFReport from "./pdf-report";
import useBankDisbursmentReportService from "./use-bank-disbursment-report-service";
import { bankHeaders } from "./bankDisbursmentReport.data";
import { file } from "jszip";
import { exportBankReportToCSV } from "./csv-report";
import { logger } from "../../../utils/logger";
import { useAuthContext } from "../../../context/authContext";
function BankDisbursmentReport() {
	const {
		bankReportListData,
		allowances,
		bankReportSummary,
		bankReportInputs,
		handleChange,
		rowsPerPage,
		currentPage,
		totalPages,
		handleNextPage,
		handlePreviousPage,
		handleRowsPerPageChange,
		searchQuery,
		setSearchQuery,
		bankReportPDFData,
		organizationInfo,
		fetchAllBankReportData,
		// loadingAllSalaryReport,
		dataFetched,
		// departmentLists,
		setDeptId,
		totalEmployee,
		paymentThrough,
		setPaymentThrough,
		bankReportFullData
	} = useBankDisbursmentReportService()
	const orgInitials = organizationInfo?.org_name?.split(' ').map(word => word[0]?.toUpperCase()).join('');
	const [openUploadImportModal, setOpenUploadImportModal] = useState(false);
	const handleCloseUploadImportModal = () => setOpenUploadImportModal(false);
	const handleOpenUploadImportModal = () => setOpenUploadImportModal(true);

	const [openChooseFormatModal, setOpenChooseFormatModal] = useState(false);
	const handleCloseChooseFormatModal = () => setOpenChooseFormatModal(false);
	const handleOpenChooseFormatModal = () => setOpenChooseFormatModal(true);

	const [selectedFileType, setSelectedFileType] = useState(null);

	const [csvDownloadLoading,setCSVDownloadLoading]=useState(false)
	const [isPaymentThrough,setIsPaymentThrough]=useState(false)

	const handleFileTypeSelection = (fileType) => {
		setSelectedFileType(fileType);
		handleCloseChooseFormatModal(false);
		setOpen(true);
	}
	const currentRoute = location.pathname.split('/').pop();
	// const [pdfReady, setPdfReady] = useState(false);
	// logger.log(openUploadImportModal,"openUploadImportModal")
	// const handleExportClick = async () => {
	//   await fetchAllSalaryReportData();
	// };
	const handleExportClick = async () => {
		// setPdfReady(false); // Reset PDF state
		await fetchAllBankReportData(); // Fetch new data based on selected department
		// setPdfReady(true); // Allow PDF download to update
		// handleOpenUploadImportModal()
	};
	const handleExportCSV = () => {
		setCSVDownloadLoading(true)
		exportBankReportToCSV(bankReportPDFData,orgInitials)
		setCSVDownloadLoading(false)
	}
	const handleExportPDF=()=>{
		handleOpenUploadImportModal()
	}

	useEffect(() => {
		handleExportClick()
		// handleExportCSV()
	}, [bankReportInputs])

	useEffect(()=>{
		handleExportClick()
	},[paymentThrough])
	const [open, setOpen] = React.useState(false);
	const handleClickOpen = () => setOpen(true);
	const handleClose = () => {
	setOpen(false);
	setIsPaymentThrough(false);
	};
	logger.log(bankReportPDFData, "bankReportPDFData-9900")
	logger.log(isPaymentThrough,"paymentThrough9999")
	return (
		<>
			<ContentLayout>

				<ContentTable>
					<GlobalTable
						headers={bankHeaders(currentPage, rowsPerPage)}
						rows={bankReportListData}
						ActiveSort={false}
						searchBox={true}
						columnManagement={true}
						avatar={true}
						stickyHeader="true"
						rowsPerPage={rowsPerPage}
						currentPage={currentPage}
						totalPages={totalPages}
						handleNextPage={handleNextPage}
						handlePreviousPage={handlePreviousPage}
						handleRowsPerPageChange={handleRowsPerPageChange}
						searchQuery={searchQuery}
						setSearchQuery={setSearchQuery}
						actionLeft={
							<>
								<Typography variant="h5" mb="0">
									Pay Acquiescent Report {dataFetched && "of "} {getMonthInStringNotOneIndexBased(bankReportPDFData[0]?.month)} {bankReportPDFData[0]?.year}
								</Typography>
							</>
						}
						actionRight={
							<>
								<InputField
									label="Report Month"
									name="month"
									type="month"
									valueSinc
									placeholder="Type Here..."
									value={bankReportInputs?.report_month}
									onChange={(e) => handleChange(e.target.value, "report_month")}
									onKeyDown={(e) => e.preventDefault()}
									max={new Date().toISOString().slice(0, 7)}
								/>
								<Button
									color="primary" variant="contained"
									// onClick={handleClickOpen}
									onClick={handleOpenChooseFormatModal}
									disabled={bankReportListData.length === 0}
								>
									Export
								</Button>
							</>
						}
					/>
				</ContentTable>
			</ContentLayout>
			<Dialog
				title={`Choose File Type`}
				closeButton={true}
				fullWidth
				maxWidth="xs"
				open={openChooseFormatModal}
				onClose={handleCloseChooseFormatModal}
				separator
				action={false}
			>
				<Row>
					<Col xs="6">
						<Button variant="outlined" fullWidth
							// disabled={isLoading}
							loading={csvDownloadLoading}
							//  onClick={handleExportCSV}
							onClick={() => handleFileTypeSelection("CSV")}
						>
							CSV File
						</Button>
					</Col>
					<Col xs="6">
						<Button variant="outlined" fullWidth
							// disabled={isLoading}
							//  onClick={handleExportPDF}
							onClick={() => handleFileTypeSelection("PDF")}
						>
							PDF File
						</Button>
					</Col>
				</Row>
			</Dialog>
			<Dialog
				title="Select Payment Through"
				closeButton={true}
				fullWidth
				maxWidth="xs"
				open={open}
				onClose={handleClose}
				onSubmit={() => {
					if (selectedFileType == "CSV") {
						handleExportCSV();
					} else if (selectedFileType == "PDF") {
						handleExportPDF();
					}
					// handleExportClick()
					// handleOpenUploadImportModal()
				}
				}
				separator
				btnDisable={!isPaymentThrough?true:false}
			>
				<SelectField
					label="Select Payment Through"
					fullWidth
					// options={departmentLists}
					options={[
						{ id: "ALL_EMP", name: "All Employees" },
						{ id: "NEFT", name: "Payment Through NEFT" },
						{ id: "IMPS", name: "Payment Through IMPS" }
					]}
					disabled={bankReportListData.length === 0}
					onChange={(e) => {
						setPaymentThrough(e)
						setIsPaymentThrough(true)
					}}
				/>
			</Dialog>
			<Dialog
				title="Pay Acquiescent Report"
				closeButton={true}
				action={false}
				fullWidth
				maxWidth="xxl"
				bodyScroll={true}
				open={openUploadImportModal}
				onClose={handleCloseUploadImportModal}

			>
				<Box height="85vh" sx={{ overflow: "hidden", borderRadius: theme.radius.list }}>
					<PDFViewer document={<SalaryReportPdf />} showToolbar={true} width="100%" height="100%" style={{ border: "none" }}>
						<BankDisbursmentPDFReport
							bankReportPDFData={bankReportPDFData}
							organizationInfo={organizationInfo}
							bankReportSummary={bankReportSummary}
							bankReportFullData={bankReportFullData}
							orgInitials={orgInitials}
						/>
					</PDFViewer>
				</Box>
			</Dialog>
		</>
	);
};

export default BankDisbursmentReport;


